import { useEffect, useRef } from 'react';
import { loadPartImages, renderPortrait, FRAME_SIZE } from '../engine/portraitRenderer';

function CharPortrait({ parts, hairColor, eyeColor, size = 64, className = '' }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    loadPartImages().then(() => {
      const canvas = canvasRef.current;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      renderPortrait(ctx, parts, hairColor, eyeColor);
    });
  }, [parts, hairColor, eyeColor]);

  return (
    <canvas
      ref={canvasRef}
      width={FRAME_SIZE}
      height={FRAME_SIZE}
      className={className}
      style={{ width: size, height: size, imageRendering: 'pixelated' }}
    />
  );
}

export default CharPortrait;
